export const closedStatuses = ['closed', 'expired', 'cancelled', 'refused'];
export const inProgressStatuses = [
  'check_in',
  'check_out',
  'in_progress',
  'locking'
];
export const runningStatuses = [
  'pending',
  'prepared',
  'check_in',
  'in_progress'
];
export const upcomingStatuses = ['prepared', 'pending'];
export const pendingStatuses = ['pending'];
export const preparedStatuses = ['prepared'];
